import { InputField } from 'components'
import LoaderButton from 'components/molecules/loader-button'
import { FieldArray, Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { Button, Table } from 'reactstrap'
import { SelectDropdownField } from 'components/molecules'
import consignmentInboundSchema from './consignment-inbound-schema'
import { STATUS } from '../../consignment-inbound-request/constants'
import { Link } from 'react-router-dom'

const propTypes = {
  onSubmit               : PropTypes.func,
  tlBrandClassifications : PropTypes.arrayOf(
    PropTypes.shape({
      id   : PropTypes.number,
      name : PropTypes.string
    })
  ),
  consignmentInboundRequest: PropTypes.object
}

const defaultProps = {
  onSubmit       : () => { },
  isFormDisabled : true
}

/**
 * Form to create new Consignment Inbound
 * @param {Function} onSubmit Handler for submitting the form
 * @param {Array} tlBrandClassifications array of ::TlBrandClassification
 * @param {Object} consignmentInbounds created ::Seller::Inbound
 * @param {Boolean} isFormDisabled to decide whether inbound form is disabled
 */
const ConsignmentInboudForm = ({
  onSubmit,
  tlBrandClassifications,
  consignmentInboundRequest
}) => {
  const consignmentInbounds = consignmentInboundRequest?.inbounds
  const isFormDisabled      = consignmentInboundRequest?.status !== STATUS.RECEIVED

  const handleClickAddClassification = (arrayHelpers) => {
    const sellerInbounds = {
      tl_brand_classification : '',
      quantity                : 0
    }
    arrayHelpers.push(sellerInbounds)
  }

  const handleClickRemove = (index, sellerInbound, arrayHelpers) => {
    const isNew = !sellerInbound.id
    if (isNew) {
      arrayHelpers.remove(index)
      return
    }

    const removedSellerInbound = {
      ...sellerInbound,
      destroy: true
    }
    arrayHelpers.replace(index, removedSellerInbound)
  }

  const handleClickUndoDelete = (index, sellerInbound, arrayHelpers) => {
    const removedInbound = {
      ...sellerInbound,
      destroy: false
    }
    arrayHelpers.replace(index, removedInbound)
  }

  const inboundDetailPath = (inboundId) => `/app/sellers/inbounds/${inboundId}/curate`

  return (
    <Formik
      enableReinitialize={ false }
      initialValues={{
        seller_inbounds: consignmentInbounds || [ {
          tl_brand_classification : '',
          quantity                : 0
        } ]
      }}
      validationSchema={ consignmentInboundSchema }
      onSubmit={ onSubmit }
    >
      {
        (formik) => (
          <Form>
            <FieldArray name='seller_inbounds'>
              {
                (arrayHelpers) => (
                  <Table
                    borderless
                    size='sm'
                    className='mb-3'
                    responsive
                  >
                    <thead>
                      <tr>
                        <th>Code</th>
                        <th>Classification</th>
                        <th>Quantity</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        formik.values.seller_inbounds.map((sellerInbound, index) => (
                          <Fragment key={ `table-row-inbound-fields-${index}` }>
                            <tr className='text-center'>
                              {
                                sellerInbound.destroy
                                  ? (
                                    <>
                                      <td colSpan={ 3 }>Consignment Inbound terhapus</td>
                                      <td className='align-middle text-default'>
                                        <Button
                                          size='sm'
                                          outline
                                          color='default'
                                          onClick={ () => handleClickUndoDelete(index, sellerInbound, arrayHelpers) }
                                          disabled={ isFormDisabled }
                                        >
                                          <i className='fas fa-undo mr-1' />{ 'Undo' }
                                        </Button>
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td className='align-middle'>
                                        {
                                          sellerInbound?.code || '-'
                                        }
                                      </td>
                                      <td className='align-middle'>
                                        <SelectDropdownField
                                          formGroupClassName={ 'mb-0' }
                                          name={ `seller_inbounds[${index}].tl_brand_classification` }
                                          getOptionValue={ (option) => option?.id }
                                          getOptionLabel={ (option) => option?.name }
                                          options={ tlBrandClassifications }
                                          disabled={ isFormDisabled }
                                        />
                                      </td>

                                      <td className='align-middle'>
                                        <InputField
                                          formGroupClassName={ 'mb-0' }
                                          type='number'
                                          name={ `seller_inbounds[${index}].quantity` }
                                          disabled={ isFormDisabled }
                                        />
                                      </td>

                                      <td className='align-middle'>
                                        <Button
                                          size='sm'
                                          outline
                                          color='danger'
                                          onClick={ () => handleClickRemove(index, sellerInbound, arrayHelpers) }
                                          disabled={ isFormDisabled }
                                        >
                                          <i className='fas fa-times-circle fa-lg mr-1 text-danger' />
                                          <span className='text-danger'>Remove</span>
                                        </Button>
                                        {
                                          sellerInbound?.id && (
                                            <Button
                                              color='primary'
                                              tag={ Link }
                                              size='sm'
                                              to={ inboundDetailPath(sellerInbound?.id) }
                                              disabled={ isFormDisabled }
                                              outline
                                            >
                                              { 'Lihat Detail' }
                                            </Button>
                                          )
                                        }
                                      </td>
                                    </>
                                  )
                              }
                            </tr>
                          </Fragment>
                        ))
                      }
                      <tr>
                        <td
                          colSpan={ 4 }
                          className={ 'text-center' }
                        >
                          <Button
                            outline
                            block
                            color={ 'primary' }
                            size={ 'sm' }
                            onClick={ () => handleClickAddClassification(arrayHelpers) }
                            disabled={ isFormDisabled }
                          >
                            { '+ Tambah Consignment Inbound' }
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )
              }
            </FieldArray>

            <LoaderButton
              className={ 'float-right' }
              color='primary'
              type='submit'
              disabled={ formik.isSubmitting || isFormDisabled }
              isLoading={ formik.isSubmitting }
              text='Simpan'
            />

          </Form>
        )
      }
    </Formik>
  )
}


ConsignmentInboudForm.propTypes    = propTypes
ConsignmentInboudForm.defaultProps = defaultProps
export default ConsignmentInboudForm
